import { userService } from "../../helpers/authservice/user.service";
import entitiesService from "@/services/entitiesService";
import authService from "@/services/auth";
import router from "../../router/index";
import store from "@/state/store";
import CryptoJS from "crypto-js";
import { retryAfterSeconds } from "@/utils/retryAfter";
var CryptoJSAesJson = {
  stringify: function (cipherParams) {
    var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function (jsonStr) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};

const user = JSON.parse(localStorage.getItem("user"));
const status = user
  ? { status: { loggeduser: true }, user }
  : { status: {}, user: null };

export const state = {
  status,
  loadingStatus: false,
  loadingSubmitStatus: false,
  userDetails: {},
  userEntities: {},
  currentEntity: {},
  userPassword: null,
  oneTimeCodeSent: null,
  emailDuplicatedCheck: null,
  phoneDuplicatedCheck: null,
  willAutoLogin: false,
  modalState: false,
  verifyPhone: false,
  verifactionLoading: false,
  userName: null,
  autoLoginByPassportID: false,
  // When a throttled credential request may be retried, as an epoch
  // millisecond. Stored as an absolute instant rather than a ticking counter so
  // that it stays correct through the vuex-persistedstate round trip - a
  // persisted countdown would come back frozen and leave the button disabled
  // forever. The screens tick their own clock and derive the seconds left.
  throttledUntil: 0,
};

export const actions = {
  /**
   * Record when a throttled request may be retried. The screens count down to
   * it; nothing here ticks, so there is no interval to leak or restart.
   */
  startThrottleCountdown({ commit }, seconds) {
    if (!seconds || seconds <= 0) return;

    commit("setThrottledUntil", Date.now() + seconds * 1000);
  },
  verifyLoginCode({ dispatch, commit }, payload) {
    commit("loadongStatus", true);
    userService.verifyLoginCode(payload.code)
    .then(async (user) => {
      console.log('verifyLoginCode state', user);
      await commit("loginSuccess", user);
      setTimeout(() => {
        commit("loadongStatus", false);
      }, 4000);
      await store.commit("user/setUserData", user.data.user);
      await store.commit("user/setCompanyName", user.data.user.company_name);
      await store.dispatch("user/saveTmpPwdStatus", user.data.user.tmp_pwd);
      await store.dispatch("user/saveUserEmail", user.data.user.email);
      await store.dispatch("user/saveUserPhone", user.data.user.phone);
      await store.dispatch("user/saveUserFirstName", user.data.user.first_name);
      await store.dispatch("user/saveUserLastName", user.data.user.last_name);
      await store.dispatch("user/saveUserTimeZone", user.data.user.timezone);
      await store.dispatch("user/saveUserQr", user.data.user.passport_qr);
      
      router.push({name: "dashboard", query: {
        onlineCompliance: true,
        visitUrl: payload.visitUrl,
        expectedVisit: true
      }
    });
      },
      (error) => {
        commit("loginFailure", error);
        commit("loadongStatus", false);
        commit("setWillAutoLogin", false);
        dispatch("notification/error", error.message, { root: true });
        if (error.message == "Link expired") {
          router.push("/link-expired");
        } else {
          if (error.retryAfter) dispatch("startThrottleCountdown", error.retryAfter);
          this._vm.$toast.error(error.message);
        }
      }
    );
  },

  changeWillAutoLogin({ commit }, payload) {
    commit("setWillAutoLogin", payload);
  },
  // Logs in the user.
  // eslint-disable-next-line no-unused-vars
  login({ dispatch, commit }, { email, password, code = '', preRegData }) {
    commit("loadongStatus", true);
    commit("loginRequest", { email });
    localStorage.setItem("userOtpRequired", 0);
    localStorage.setItem("userIsVerified", 0);
    userService.login(email, password, code).then(
      (user) => {
        // console.log('user.data', user.data);
        commit("loginSuccess", user);
        setTimeout(() => {
          commit("loadongStatus", false);
        }, 4000);
        localStorage.setItem("userDetails", JSON.stringify(user.data.user));
        store.commit("user/setUserData", user.data.user);
        store.commit("user/setCompanyName", user.data.user.company_name);
        store.commit("user/setUserOtpRequired", user.data.otp_required ? 1 : 0);
        localStorage.setItem("userOtpRequired", user.data.otp_required ? 1 : 0);
        
        store.commit("user/setUserIsVerified", 0);
        localStorage.setItem("userIsVerified", 0);

        store.dispatch("user/saveTmpPwdStatus", user.data.user.tmp_pwd);
        store.dispatch("user/saveUserEmail", user.data.user.email);
        store.dispatch("user/saveUserPhone", user.data.user.phone);
        store.dispatch("user/saveUserFirstName", user.data.user.first_name);
        store.dispatch("user/saveUserLastName", user.data.user.last_name);
        store.dispatch("user/saveUserTimeZone", user.data.user.timezone);
        store.dispatch("user/saveUserQr", user.data.user.passport_qr);

        // If user coming from cloud to fill preregistration form, redirect him/her to cloud again
        //  after sending user information on passport + the information that coming from cloud back  
        if (preRegData.redirect_url) {
          return new Promise((resolve, reject) => {
            entitiesService
              .getUserEntitiesForPreReg(user.data.user.id)
              .then((data) => {
                resolve(data);
                window.location.href = preRegData.redirect_url +
                  `?comingFromPassport=${true}` +
                  '&first_name=' + encodeURIComponent(user.data.user.first_name) +
                  '&last_name=' + encodeURIComponent(user.data.user.last_name) +
                  `&getUserEntities=${data.data.data.length > 0 ? true : false}` +
                  '&encId=' + encodeURIComponent(user.data.user.encId) +
                  (user.data.user.id ? '&passport_id=' + encodeURIComponent(user.data.user.id) : '') +
                  (user.data.user.email ? '&email=' + encodeURIComponent(user.data.user.email) : '') +
                  (user.data.user.phone ? '&phone=' + encodeURIComponent(user.data.user.phone) : '') +
                  (user.data.user.passport_qr ? '&passport_qr=' + encodeURIComponent(user.data.user.passport_qr) : '') +
                  (user.data.user.image ? '&image=' + encodeURIComponent(user.data.user.image) : '') +
                  (user.data.user.company_name ? '&company_name=' + encodeURIComponent(user.data.user.company_name) : '') +
                  '&preRegData=' + JSON.stringify(preRegData);

              })
              .catch((err) => {
                reject(err);
                commit("setLoading", false);
              });
          });

        } else if (router.currentRoute.query.add_visitor) {
          window.location.href =
          router.currentRoute.query.serverUrl +
            `/pre-registration/${router.currentRoute.query.visit_url}?` +
            `add_visitor=${true}&comingFromPassport=${true}` +
            '&first_name=' + encodeURIComponent(user.data.user.first_name) +
            '&last_name=' + encodeURIComponent(user.data.user.last_name) +
            (user.data.user.passport_qr
              ? "&passport_qr=" + encodeURIComponent(user.data.user.passport_qr)
              : "") +
            (user.data.user.passport_qr
              ? "&passport_id=" + encodeURIComponent(user.data.user.id)
              : "") +
            (user.data.user.image ? '&image=' + encodeURIComponent(user.data.user.image) : '');
        } else {
          if( user.data.otp_required){
            router.push("/verify-otp-code");
          }else{
            router.push("/dashboard");
          }
        }
      },
      (error) => {
        commit("loginFailure", error);
        commit("loadongStatus", false);
        commit("setWillAutoLogin", false);
        dispatch("notification/error", error.message, { root: true });
        if (error.message == "Link expired") {
          router.push("/link-expired");
        } else {
          if (error.retryAfter) dispatch("startThrottleCountdown", error.retryAfter);
          this._vm.$toast.error(error.message);
        }
      }
    );
  },
  //auto login using passport id
  generatePassportToken({ commit }, id) {
    return new Promise((resolve, reject) => {
      authService
        .generatePassportToken(id)
        .then((user) => {
          resolve(user);
          commit("setAutoLoginByPassportID", true);
          localStorage.setItem("user", JSON.stringify(user.data));
          commit("loginSuccess", user);
          store.commit("user/setUserData", user.data.data.user);
          store.commit("user/setCompanyName", user.data.data.user.company_name);
          store.dispatch("user/saveTmpPwdStatus", user.data.data.user.tmp_pwd);
          store.dispatch("user/saveUserEmail", user.data.data.user.email);
          store.dispatch("user/saveUserPhone", user.data.data.user.phone);
          store.dispatch(
            "user/saveUserFirstName",
            user.data.data.user.first_name
          );
          store.dispatch(
            "user/saveUserLastName",
            user.data.data.user.last_name
          );
          store.dispatch("user/saveUserTimeZone", user.data.data.user.timezone);
          router.push("/dashboard");
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          commit("setModalState", false);
        });
    });
  },
  // forget password
  forgetPassword({ commit, dispatch }, params) {
    commit("loadongStatus", true);
    return new Promise((resolve, reject) => {
      authService
        .forgetPassword(params)
        .then((data) => {
          resolve(data);
          commit("loadongStatus", false);
          isNaN(params.email)
            ? router.push("/success-email")
            : commit("setVerifyPhone", true);
        })
        .catch((err) => {
          reject(err);
          commit("loadongStatus", false);
          dispatch("startThrottleCountdown", retryAfterSeconds(err));
          this._vm.$toast.error(err.response.data.message);
        });
    });
  },
  resetPassword({ commit }, params) {
    commit("setVerifactionLoading", true);
    return new Promise((resolve, reject) => {
      authService
        .resetPassword(params)
        .then((data) => {
          resolve(data);
          commit("setVerifactionLoading", false);
          this._vm.$toast.success(data.data.message);
        })
        .catch((err) => {
          reject(err);
          commit("setVerifactionLoading", false);
          this._vm.$toast.error(err.response.data.message);
        });
    });
  },
  verifyPhone({ commit }, params) {
    commit("setVerifactionLoading", true);
    return new Promise((resolve, reject) => {
      authService
        .verifyPhone(params)
        .then((data) => {
          resolve(data);
          commit("setVerifactionLoading", false);
          this._vm.$toast.success(data.data.message);
          router.push(`/reset-password/${params.token}/${params.phone}`);
        })
        .catch((err) => {
          reject(err);
          commit("setVerifactionLoading", false);
          // this._vm.$toast.error(err.response.data.message);
        });
    });
  },
  // Logout the user
  logout({ commit }, payload) {
    return new Promise((resolve, reject) => {
      authService
        .logout()
        .then((data) => {
          resolve(data);
          commit("logout");
          localStorage.clear();
          store.dispatch("user/saveUserEmail", null);
          store.dispatch("user/saveUserPhone", null);
          store.dispatch("user/saveUserFirstName", null);
          store.dispatch("user/saveUserLastName", null);
          store.dispatch("user/saveUserTimeZone", null);
          store.dispatch("user/saveUserNewImage", null);
          store.dispatch("user/saveUserQr", null);
          store.commit("user/setEncPwd", null);
          store.commit("user/setEncEmail", null);
          store.commit("user/setCompanyName", null);
          store.commit("user/setIp", null);
          store.commit("user/setUserData", null);
          store.commit("user/setUserOtpRequired", false); 
          localStorage.setItem("userOtpRequired", 0);
          localStorage.setItem("userIsVerified", 0);
          commit("setWillAutoLogin", false);
          console.log('payload', payload);
          if (payload && payload.add_visitor) {
            router.push({
              name: "login",
              query: { email: payload.email, add_visitor: true, visit_url: payload.visit_url, serverUrl: payload.serverUrl },
            });
          } else if (payload && payload.comingFromPassport) {
            router.push({
              name: "login",
              query: {
                email: payload.email,
                comingFromPassport: true,
                redirect_url: payload.redirect_url,
                visit_date: payload.visit_date,
                visit_time: payload.visit_time,
                area_id: payload.area_id,
                registration_method: payload.registration_method,
                entity_id: payload.entity_id,
                user_type_id: payload.user_type_id,
                journey_flow_id: payload.journey_flow_id,
                emailExists: payload.emailExists
              },
            });
          } else if (payload) {
            router.push({
              name: "login",
              query: { email: payload },
            });
          } else
            router.push("/login");
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // register dashboard
  registeruser({ dispatch, commit }, user) {
    commit("setLoadingSubmitStatus", true);
    commit("loginRequest", user);
    return new Promise((resolve, reject) => {
      authService
        .registerUser(user)
        .then((data) => {
          resolve(data);
          commit("setLoadingSubmitStatus", false);
          dispatch(
            "notification/success",
            "Registration successful. Please check your email for credentials",
            {
              root: true,
            }
          );
          user.form.user.email
            ? router.push("/success-register")
            : (router.push("/success-sms"),
              commit("setUserName", user.form.user.phone));
        })
        .catch((err) => {
          reject(err);
          commit("registerFailure", err);
          dispatch("notification/error", err.response.data.errors, {
            root: true,
          });
          commit("setLoadingSubmitStatus", false);
          commit("loginFailure", err);
          if (err.response.data && err.response.data.errors) {
            this._vm.$toast.error(
              Object.values(err.response.data.errors).join("\r\n")
            );
          } else if (err.response.data && err.response.data.data) {
            this._vm.$toast.error(err.response.data.data);
          }
        });
    });
  },
  // register passport
  passportRegisteration({ commit }, user) {
    commit("setLoadingSubmitStatus", true);
    commit("loginRequest", user);
    return new Promise((resolve, reject) => {
      authService
        .passportRegisteration(user)
        .then((data) => {
          resolve(data);
          commit("setLoadingSubmitStatus", false);
          user.email
            ? router.push("/success-register")
            : (router.push(`/success-sms`), commit("setUserName", user.phone));
        })
        .catch((err) => {
          reject(err);
          commit("setLoadingSubmitStatus", false);
          commit("loginFailure", err);
          commit("registerFailure", err);
          if (err.response.data && err.response.data.errors) {
            this._vm.$toast.error(
              Object.values(err.response.data.errors).join("\r\n")
            );
          }
        });
    });
  },
  // check duplicated
  checkDuplicated({ dispatch, commit }, params) {
    commit("loadongStatus", true);
    return new Promise((resolve, reject) => {
      authService
        .checkDuplicated(params)
        .then((data) => {
          resolve(data);
          params.field == "phone"
            ? commit("setPhoneDuplicatedCheck", data.data.data)
            : commit("setEmailDuplicatedCheck", data.data.data);
          if (data.data.data) {
            commit("loadongStatus", false);
          }
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(
            Object.values(err.response.data.errors).join("\r\n")
          );
          commit("registerFailure", err);
          dispatch("notification/error", err.response.data.errors, {
            root: true,
          });
          commit("loadongStatus", false);
          commit("loginFailure", err);
        });
    });
  },
  // get entity by subdomain
  onEntityBySubdomain({ commit }, params) {
    return new Promise((resolve, reject) => {
      authService
        .entityBySubdomain(params)
        .then((data) => {
          commit("setEntityBySubdomain", data.data.data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  // user details
  fetchuserDetails({ commit }, id) {
    return new Promise((resolve, reject) => {
      authService
        .getUserDetails(id)
        .then((data) => {
          localStorage.setItem("userDetails", JSON.stringify(data.data.data));
          commit("userDetails", data.data);
          resolve(data);
          store.commit("user/setUserDataImg", data.data.data.image);
          // dispatch("fetchuserEntities", data.data.id);
        })
        .catch((err) => reject(err));
    });
  },
  // user entities
  fetchuserEntities({ commit }, userId) {
    return new Promise((resolve, reject) => {
      userService
        .userEntities(userId)
        .then((data) => {
          localStorage.setItem("userEntities", JSON.stringify(data.data));
          commit("userEntities", data.data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  sendVisitortoGetOneTimeCode({ commit }, visitor) {
    commit("setOneTimeCodeSent", true);
    return authService.oneTimeLoginService(visitor);
  },
  verifyOneTimeCode({ commit }, data) {
    commit("setOneTimeCodeSent", false);
    const key = localStorage.getItem("serverId");
    let encryptedUsername = data.username;
    if (!data.encrypted) {
      encryptedUsername = btoa(
        CryptoJS.AES.encrypt(JSON.stringify(data.username), key, {
          format: CryptoJSAesJson,
        }).toString()
      );
    }

    let verify_data = {
      username: encryptedUsername,
      code: data.oneTimeCode,
    };

    return new Promise((resolve, reject) => {
      authService
        .verifyOneTimeCodeService(verify_data)
        .then((res) => {
          resolve(res);
          let user = res.data;
          if (user.data.access_token) {
            localStorage.setItem("user", JSON.stringify(user));
          }
          commit("loginSuccess", user);
          store.commit("user/setUserData", user.data.user);
          store.commit("user/setCompanyName", user.data.user.company_name);
          store.dispatch("user/saveTmpPwdStatus", user.data.user.tmp_pwd);
          store.dispatch("user/saveUserEmail", user.data.user.email);
          store.dispatch("user/saveUserPhone", user.data.user.phone);
          store.dispatch("user/saveUserFirstName", user.data.user.first_name);
          store.dispatch("user/saveUserLastName", user.data.user.last_name);
          store.dispatch("user/saveUserTimeZone", user.data.user.timezone);
          store.dispatch("user/saveUserQr", user.data.user.passport_qr);
        })
        .catch((err) => reject(err));
    });
  },
  setCurrentEntity({ commit }, entity) {
    commit("currentEntity", entity);
  },
  saveKioskPackage({ commit }, payload) {
    commit("setKioskPackage", payload);
  },
  saveUserPassword({ commit }, payload) {
    commit("setUserPassword", payload);
  },
  // reset
  resetLoading({ commit }) {
    commit("loadongStatus", false);
    commit("setModalState", false);
    commit("entity/setSubdomain", null, { root: true });
    commit("setPhoneDuplicatedCheck", null);
    commit("setEmailDuplicatedCheck", null);
    commit("setVerifyPhone", false);
    commit("setAutoLoginByPassportID", false);
  },
  resetUsername({ commit }) {
    commit("setUserName", null);
  },
  resetOneTimeCodeSent({ commit }) {
    commit("setOneTimeCodeSent", false);
  },
  fetchUserOtpAuthStatus({ commit }) {
    commit("loadongStatus", false);
    return new Promise((resolve, reject) => {
      authService
        .getUserOtpAuthStatus()
        .then((data) => {
          resolve(data);
          // commit("user/setUserOtpRequired", data.data);
        })
        .catch((err) => reject(err));
    });
  },
  updateUserOtpAuthStatus({ commit }, payload) {
    commit("loadongStatus", false);
    return new Promise((resolve, reject) => {
      authService
        .updateUserOtpAuthStatus(payload)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success(data.message);
        })
        .catch((err) => {
          reject(err)
          this._vm.$toast.error(err.data.message);
        });
    });
  },
  sendOtpAuthCode({ commit }, payload) {
    commit("loadongStatus", false);
    return new Promise((resolve, reject) => {
      authService
        .sendOtpAuthCode(payload)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success(data.message);
        })
        .catch((err) => {
          reject(err)
          this._vm.$toast.error(err.data.message);
        });
    });
  },
  verifyOtpAuthCode({ commit }, payload) {
    commit("loadongStatus", false);
    return new Promise((resolve, reject) => {
      authService
        .verifyOtpAuthCode(payload)
        .then((data) => {
          resolve(data);
          this._vm.$toast.success(data.message);
        })
        .catch((err) => {
          reject(err)
          this._vm.$toast.error(err.data.message);
        });
    });
  },
};

export const mutations = {
  setThrottledUntil(state, timestamp) {
    state.throttledUntil = timestamp;
  },
  setWillAutoLogin(state, payload) {
    state.willAutoLogin = payload;
  },
  loadongStatus(state, loading) {
    state.loadingStatus = loading;
  },
  setVerifactionLoading(state, loading) {
    state.verifactionLoading = loading;
  },
  setLoadingSubmitStatus(state, loading) {
    state.loadingSubmitStatus = loading;
  },
  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, user) {
    state.status = { loggeduser: true };
    state.user = user;
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
  },
  logout(state) {
    state.status = {};
    state.user = null;
  },
  registerRequest(state) {
    state.status = { registering: true };
  },
  registerSuccess(state) {
    state.status = {};
  },
  registerFailure(state) {
    state.status = {};
  },
  // user details
  userDetails(state, user) {
    state.userDetails = user;
  },
  // user entities
  userEntities(state, entities) {
    state.userEntities = entities;
  },
  // current entity
  currentEntity(state, entity) {
    state.currentEntity = entity;
  },
  // user pass
  setUserPassword(state, payload) {
    state.userPassword = payload;
  },
  setEmailDuplicatedCheck(state, payload) {
    state.emailDuplicatedCheck = payload;
  },
  setPhoneDuplicatedCheck(state, payload) {
    state.phoneDuplicatedCheck = payload;
  },
  setModalState(state, payload) {
    state.modalState = payload;
  },
  setVerifyPhone(state, payload) {
    state.verifyPhone = payload;
  },
  setUserName(state, payload) {
    state.userName = payload;
  },
  setAutoLoginByPassportID(state, payload) {
    state.userName = payload;
  },
  setOneTimeCodeSent(state, payload) {
    state.oneTimeCodeSent = payload;
  },
};

export const getters = {
  throttledUntil(state) {
    return state.throttledUntil;
  },
  getWillAutoLogin(state) {
    return state.willAutoLogin;
  },
  loadingStatus(state) {
    return state.loadingStatus;
  },
  getVerifactionLoading(state) {
    return state.verifactionLoading;
  },
  getLoadingSubmitStatus(state) {
    return state.loadingSubmitStatus;
  },
  userDetails(state) {
    return state.userDetails;
  },
  userEntities(state) {
    return state.userEntities;
  },
  currentEntity(state) {
    return state.currentEntity;
  },
  getUserPassword(state) {
    return state.userPassword;
  },
  getEmailDuplicatedCheck(state) {
    return state.emailDuplicatedCheck;
  },
  getPhoneDuplicatedCheck(state) {
    return state.phoneDuplicatedCheck;
  },
  getModalState(state) {
    return state.modalState;
  },
  getVerifyPhone(state) {
    return state.verifyPhone;
  },
  getUserName(state) {
    return state.userName;
  },
  getAutoLoginByPassportID(state) {
    return state.autoLoginByPassportID;
  },
  getOneTimeCodeSent(state) {
    return state.oneTimeCodeSent;
  },
};
